import createVueComponent from '../createVueComponent';

const Tablet = createVueComponent('TabletIcon', [
  ['rect', { x: '4', y: '2', width: '16', height: '20', rx: '2', ry: '2' }],
  ['line', { x1: '12', y1: '18', x2: '12.01', y2: '18' }],
]);

export default Tablet;
